import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Outlinebutton from "../Customcomponents/Outlinebutton";
import Primarybutton from "../Customcomponents/Primarybutton";
import { getProfile, postProject } from "../api/service";
import { toast } from "react-toastify";

// Constants for delay_insurance / quotation_value validation (F3 prep)
const QUOTATION_MIN = 50001;
const AMIT_USER_ID = 48; // amit@reminiscent.in - superuser override

// Convert integer rupees to Indian-format words (lakh/crore system)
const numberToIndianWords = (num) => {
  if (num === null || num === undefined || num === "") return "";
  const n = parseInt(num, 10);
  if (isNaN(n) || n === 0) return "";
  if (n < 0) return "";

  const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen",
    "Eighteen", "Nineteen"];
  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  const twoDigits = (x) => {
    if (x < 20) return ones[x];
    return tens[Math.floor(x / 10)] + (x % 10 ? " " + ones[x % 10] : "");
  };
  const threeDigits = (x) => {
    const h = Math.floor(x / 100);
    const r = x % 100;
    let s = "";
    if (h) s += ones[h] + " Hundred";
    if (r) s += (s ? " " : "") + twoDigits(r);
    return s;
  };

  let result = "";
  const crore = Math.floor(n / 10000000);
  const lakh = Math.floor((n % 10000000) / 100000);
  const thousand = Math.floor((n % 100000) / 1000);
  const rest = n % 1000;

  if (crore) result += threeDigits(crore) + " Crore";
  if (lakh) result += (result ? " " : "") + twoDigits(lakh) + " Lakh";
  if (thousand) result += (result ? " " : "") + twoDigits(thousand) + " Thousand";
  if (rest) result += (result ? " " : "") + threeDigits(rest);

  return result + " Rupees Only";
};

const Salesaddprojects = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isEditing, setIsEditing] = useState(null);
  // Snapshot of project status as loaded from server. Drives post-F3 lock UI.
  // Stays stable across in-form edits (does NOT update from projectPayload).
  const [originalStatus, setOriginalStatus] = useState(null);
  const [originalQuotationValue, setOriginalQuotationValue] = useState(null);
  const curUsrRole = localStorage.getItem("role");
  const currentUserId = localStorage.getItem("userid");
  const canEditSalesTeam = !(
    isEditing !== null &&
    (curUsrRole === "sales_head" || curUsrRole === "sales_team")
  );
  const canEditCivilTeam = !(
    isEditing !== null &&
    (curUsrRole === "civil_head" || curUsrRole === "civil_team")
  );

  const canEditAccounts = !(isEditing !== null && curUsrRole === "accounts");
  const canEditDesign = !(
    isEditing !== null &&
    (curUsrRole === "design_head" || curUsrRole === "design_team")
  );

  /*
    isEditing=null -> view project
    isEdting=false -> adding project
    isEditing=true -> editing project
  */
  const executionCentreChoices = [
    { key: "bangalore", display: "Bangalore" },
    { key: "hyderabad", display: "Hyderabad" },
    { key: "mumbai", display: "Mumbai" },
    { key: "delhi", display: "Delhi" },
  ];

  const workModuleChoices = [
    { key: "modular", display: "Fast Track" },
    { key: "manual", display: "Normal" },

  ];
  const [customers, setCustomers] = useState([]);
  const [projectPayload, setProjectPayload] = useState({
    work_module_cp: null,
    customer: "",
    address: "",
    city: "",
    location: "",
    required_docs: "",
    pr_weekends: "",
    pr_weekdays: "",
    token_received: null,
    tdc: null,
    work_module_ct: "",
    execution_centre: "",
    site_marking_date: null,
    site_marking: null,
    ho_date_ce: null,
    exp_3D_closure_date: null,
    closure_date_2D: null,
    first_2d_release_date: null,
    material_selection_at_sales_ho: null,
    quotation_value: null,
    delay_insurance: null,
    material_selection: null,
    ho_date_sales_ce: null,
    received_on: null,
    received_amount: null,
  });

  const canEditSalesTeamHoCall = !(
    !canEditSalesTeam && projectPayload.exp_3D_closure_date !== null
  );
  // canEditDelayInsurance: follows the inverted-naming convention (true = disabled).
  // After F3 fires (project status = "Project under execution", indicated by ho_date_sales_ce being set),
  // only amit@reminiscent.in (id 48) or civil_head can edit. Before that, anyone with section access can.
  const canEditDelayInsurance = !(
    !canEditSalesTeamHoCall && (
      projectPayload.ho_date_sales_ce === null ||
      parseInt(currentUserId) === AMIT_USER_ID ||
      curUsrRole === "civil_head"
    )
  );
  // Post-F3 locks: derived from server-side originalStatus, not in-form state.
  const isProjectInExecution = originalStatus === "Project under execution";
  // ho_date_sales_ce: locked for everyone once project is under execution.
  const canEditHoDateSalesCe = canEditSalesTeamHoCall || isProjectInExecution;
  // quotation_value: override the section lock for amit + civil_head + civil_team
  // when project is under execution. Inverted naming (true = disabled).
  const canEditQuotationValue = (
    isProjectInExecution
      ? !(
          parseInt(currentUserId) === AMIT_USER_ID ||
          curUsrRole === "civil_head" ||
          curUsrRole === "civil_team"
        )
      : canEditSalesTeamHoCall
  );

  //to get customer list
  function getCustomers() {
    getProfile({ role: "customer", active: "True", pagination: false })
      .then((res) => {
        setCustomers(res);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }
  useEffect(() => {
    getCustomers();
    let prevState = location.state;
    if (prevState) {
      setIsEditing(prevState.isEditing);
      if (prevState.isEditing === false) {
        setProjectPayload({
          ...projectPayload,
          users_assigned: [currentUserId],
        });
      } else if (
        prevState.isEditing === null ||
        prevState.isEditing !== false
      ) {
        setProjectPayload({
          id: prevState.data.id,
          work_module_cp: prevState.data.work_module_cp,
          customer: prevState.data.customer.id,
          address: prevState.data.address,
          city: prevState.data.city,
          location: prevState.data.location,
          required_docs: prevState.data.required_docs,
          pr_weekends: prevState.data.pr_weekends,
          pr_weekdays: prevState.data.pr_weekdays,
          token_received: prevState.data.token_received,
          work_module_ct: prevState.data.work_module_ct,
          execution_centre: prevState.data.execution_centre || "",
          site_marking_date: prevState.data.site_marking_date,
          site_marking: prevState.data?.site_marking?.toString(),
          ho_date_ce: prevState.data.ho_date_ce,
          final_amount_collected: prevState.data.final_amount_collected,
          final_amount_pending: prevState.data.final_amount_pending,
          exp_3D_closure_date: prevState.data.exp_3D_closure_date,
          closure_date_2D: prevState.data.closure_date_2D,
          first_2d_release_date: prevState.data.first_2d_release_date,
          material_selection_at_sales_ho:
            prevState.data.material_selection_at_sales_ho,
          quotation_value: prevState.data.quotation_value,
          delay_insurance: prevState.data.delay_insurance,
          material_selection: prevState.data.material_selection,
          ho_date_sales_ce: prevState.data.ho_date_sales_ce,
          received_on: prevState.data.received_on,
          received_amount: prevState.data.received_amount,
          tdc: prevState.data.tdc,
        });
        // Capture server-side status for post-F3 lock UI
        setOriginalStatus(prevState.data.status);
        // Capture original quotation_value to gate first-time-entry popup correctly
        setOriginalQuotationValue(prevState.data.quotation_value);
      }
    }
  }, []);

  function handleChangeField(event) {
    let name = event.target.name;
    let value = event.target.value;
    setProjectPayload({ ...projectPayload, [name]: value });
  }

  function handleSubmitForm(event) {
    event.preventDefault();
    // F3-prep validation: enforce >= 50,001 minimum, AND require delay_insurance
    // ONLY on FIRST-TIME quotation entry (i.e., when value transitions from null/0 to a real number).
    // Subsequent quotation edits are not blocked even if delay_insurance is null
    // (matches backend rule, see ProjectListCreateSerializer.validate).
    const qv = projectPayload.quotation_value;
    const qvNum = parseInt(qv, 10);
    const isQuotationSet = qv !== null && qv !== "" && qv !== undefined && !isNaN(qvNum) && qvNum > 0;
    if (isQuotationSet && qvNum < QUOTATION_MIN) {
      toast.error("Net Quotation Amount must be greater than 50,000.");
      return;
    }
    // First-time check: only block if there is currently NO quotation set in projectPayload's
    // historical state (we infer "first time" from edit-load: projectPayload was loaded with
    // quotation_value either null OR 0 from server. We don't have a separate "originalQuotation"
    // ref, but the server backend will catch this case as defense in depth).
    // Frontend rule: if quotation is set AND delay_insurance is null AND user has not previously
    // saved this project with a quotation (i.e., this is a fresh entry), block.
    // Simpler heuristic: if delay_insurance is still null at submit time AND quotation is set, prompt.
    // The backend will distinguish "first-time" vs "re-save" precisely; here we prompt only if user is
    // clearly entering a quotation while delay_insurance is empty.
    // First-time quotation entry = original was null/0/empty AND incoming is set.
    // Subsequent edits to quotation on already-quoted projects do NOT trigger the popup
    // (matches backend rule in ProjectListCreateSerializer.validate).
    const isFirstTimeQuotationEntry =
      originalQuotationValue === null ||
      originalQuotationValue === undefined ||
      originalQuotationValue === 0 ||
      originalQuotationValue === "";
    if (isQuotationSet && isFirstTimeQuotationEntry && (projectPayload.delay_insurance === null || projectPayload.delay_insurance === undefined)) {
      alert("Net quotation amount cannot be saved since Delay Insurance is not selected. Please select Yes or No before saving.");
      return;
    }

    if (!isSubmitted) {
      setIsSubmitted(true);
      postProject(projectPayload)
        .then((res) => {
          toast.success(
            `Project details are ${isEditing ? "updated" : "added"}`
          );
          setIsSubmitted(false);
          navigate("/salesprojects");
        })
        .catch((err) => {
          setIsSubmitted(false);
          toast.error(err.message);
        });
    }
  }

  return (
    <React.Fragment>
      <div className="banner-section">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item headingfour">
                  <Link to="/salesprojects">Projects</Link>
                </li>
                <li
                  class="breadcrumb-item active m-auto"
                  aria-current="page"
                  style={{ fontSize: "18px" }}
                >
                  {isEditing === null ? "View" : isEditing ? "Edit" : "Add"}
                  Project
                </li>
              </ol>
            </nav>
          </div>
          <div>
            <Link to="/salesprojects">
              <button
                className="outline_btn d-flex flex-row"
                style={{ width: "120px" }}
              >
                <span>Back</span>
              </button>
            </Link>
          </div>
        </div>
        <hr />
        <div className="banner-section-dashboard mt-2 mb-3">
          <div className="table_section">
            <h6 className="mb-3 headingfive">Sales Team (Token Received)</h6>
            <Form onSubmit={handleSubmitForm}>
              <Row>
                <Form.Group
                  className="col-md-12 col-lg-6 mb-2"
                  controlId="formGridEmail"
                >
                  <Form.Label
                    className={canEditSalesTeam ? "disabled-label" : ""}
                  >
                    Customer
                  </Form.Label>
                  <Form.Select
                    className="inputfield"
                    name="customer"
                    onChange={handleChangeField}
                    value={projectPayload.customer}
                    disabled={canEditSalesTeam}
                    required
                  >
                    <option hidden value="">
                      Select customer
                    </option>
                    {customers.map((customer) => {
                      return (
                        <option
                          value={customer.user?.id}
                          name={"customer"}
                          onChange={handleChangeField}
                        >
                          {customer.user?.first_name} {customer.user.last_name}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
                <Form.Group
                  className="col-md-12 col-lg-6 mb-2"
                  controlId="formGridCity"
                >
                  <Form.Label
                    className={canEditSalesTeam ? "disabled-label" : ""}
                  >
                    Property Address
                  </Form.Label>
                  <textarea
                    class="form-control inputfield"
                    id="exampleFormControlTextarea1"
                    rows="2"
                    name="address"
                    value={projectPayload.address}
                    onChange={handleChangeField}
                    disabled={canEditSalesTeam}
                    required
                  ></textarea>
                </Form.Group>
              </Row>

              <Row>
                <Form.Group
                  className="col-md-12 col-lg-6 mb-2"
                  controlId="formGridCity"
                >
                  <Form.Label
                    className={canEditSalesTeam ? "disabled-label" : ""}
                  >
                    City
                  </Form.Label>
                  <Form.Control
                    type="text"
                    className="inputfield"
                    name="city"
                    value={projectPayload.city}
                    onChange={handleChangeField}
                    disabled={canEditSalesTeam}
                    required
                  />
                </Form.Group>

                <Form.Group
                  className="col-md-12 col-lg-6 mb-2"
                  controlId="formGridState"
                >
                  <Form.Label
                    className={canEditSalesTeam ? "disabled-label" : ""}
                  >
                    Map URL
                  </Form.Label>
                  <Form.Control
                    type="url"
                    className="inputfield"
                    name="location"
                    value={projectPayload.location}
                    onChange={handleChangeField}
                    disabled={canEditSalesTeam}
                    required
                  />
                </Form.Group>
              </Row>

              <Row>
                <Form.Group
  className="mb-2 col-lg-6 col-md-12 mb-2"
  controlId="formGridAddress1"
>
  <Form.Label
    className={canEditSalesTeam ? "disabled-label" : ""}
  >
    Gross Quotation Value
  </Form.Label>
  <Form.Control
    type="number"
    className="inputfield"
    name="required_docs"
    value={projectPayload.required_docs}
    onChange={handleChangeField}
    disabled={canEditSalesTeam}
    required
    min="0" // Optional: Ensures only positive numbers are entered
    step="any" // Optional: Allows for decimal numbers; adjust if you need integer values only
  />
</Form.Group>

              </Row>
              <Row>
                <Form.Group
                  className="mb-2 col-lg-6 col-md-12 mb-2"
                  controlId="formGridAddress1"
                >
                  <Form.Label
                    className={canEditSalesTeam ? "disabled-label" : ""}
                  >
                    Property Restrictions - weekend
                  </Form.Label>
                  <Form.Control
                    type="text"
                    className="inputfield"
                    name="pr_weekends"
                    value={projectPayload.pr_weekends}
                    onChange={handleChangeField}
                    disabled={canEditSalesTeam}
                    required
                  />
                </Form.Group>
                <Form.Group
                  className="mb-2 col-lg-6 col-md-12 mb-2"
                  controlId="formGridAddress1"
                >
                  <Form.Label
                    className={canEditSalesTeam ? "disabled-label" : ""}
                  >
                    Is Site Ready for measurement?
                  </Form.Label>
                  <Form.Control
                    type="text"
                    className="inputfield"
                    name="pr_weekdays"
                    value={projectPayload.pr_weekdays}
                    onChange={handleChangeField}
                    disabled={canEditSalesTeam}
                    required
                  />
                </Form.Group>
              </Row>

              <Row>
                <Form.Group
                  className="col-md-12 col-lg-6 mb-2"
                  controlId="formGridEmail"
                >
                  <Form.Label
                    className={canEditSalesTeam ? "disabled-label" : ""}
                  >
                    Token Received On
                  </Form.Label>
                  <Form.Control
                    type="date"
                    className="inputfield form-control date-control"
                    name="token_received"
                    value={projectPayload.token_received}
                    onChange={handleChangeField}
                    disabled={canEditSalesTeam}
                  />
                </Form.Group>

                <Form.Group
                  className="col-md-12 col-lg-6 mb-2"
                  controlId="formGridPassword"
                >
                  <Form.Label
                    className={canEditSalesTeam ? "disabled-label" : ""}
                  >
                   Site Measurement Required on
                  </Form.Label>
                  <Form.Control
                    type="date"
                    className="inputfield form-control date-control"
                    name="tdc"
                    value={projectPayload.tdc}
                    onChange={handleChangeField}
                    disabled={canEditSalesTeam}
                    required
                  />
                </Form.Group>
              </Row>

              <Row>
                <Form.Group className="col-md-12 col-lg-6 mb-2">
                  <Form.Label
                    className={canEditSalesTeam ? "disabled-label" : ""}
                  >
                   Project Type
                  </Form.Label>
                  <Form.Select
                    className="inputfield"
                    name="work_module_cp"
                    value={projectPayload.work_module_cp}
                    onChange={handleChangeField}
                    disabled={canEditSalesTeam}
                    required
                  >
                    <option hidden value="">
                      Select work module
                    </option>
                    {workModuleChoices.map((workModuleChoice) => {
                      return (
                        <option value={workModuleChoice["key"]}>
                          {workModuleChoice["display"]}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
              </Row>
              <hr />
              <h6 className="mb-3 headingfive">Projects Team</h6>
              <Row>
                <Form.Group
                  className="col-md-12 col-lg-6 mb-3"
                  controlId="formGridEmail"
                >
                  <Form.Label
                    className={canEditCivilTeam ? "disabled-label" : ""}
                  >
                    Site measurement Date
                  </Form.Label>
                  <Form.Control
                    type="date"
                    className="inputfield form-control date-control"
                    disabled={canEditCivilTeam}
                    name="site_marking_date"
                    value={projectPayload.site_marking_date}
                    onChange={handleChangeField}
                  />
                </Form.Group>

                <Form.Group
                  className="col-md-12 col-lg-6 mb-2"
                  controlId="formGridPassword"
                >
                  <Form.Label
                    className={canEditCivilTeam ? "disabled-label" : ""}
                  >
                    Is Site measurement completed
                  </Form.Label>
                  <div className="col-md-6">
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="site_marking"
                        id="inlineRadio1"
                        value="true"
                        disabled={canEditCivilTeam}
                        checked={projectPayload.site_marking == "true"}
                        onChange={handleChangeField}
                      />
                      <label class="form-check-label" for="inlineRadio1">
                        Yes
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="site_marking"
                        id="inlineRadio2"
                        value="false"
                        disabled={canEditCivilTeam}
                        checked={projectPayload.site_marking == "false"}
                        onChange={handleChangeField}
                      />
                      <label class="form-check-label" for="inlineRadio2">
                        No
                      </label>
                    </div>
                  </div>
                </Form.Group>
              </Row>

              <Row>
                <Form.Group
                  className="col-lg-6 col-md-12 mb-2"
                  controlId="formGridEmail"
                >
                  <Form.Label
                    className={canEditCivilTeam ? "disabled-label" : ""}
                  >
                    Handover by Sales on
                  </Form.Label>
                  <Form.Control
                    type="date"
                    className="inputfield form-control date-control"
                    disabled={canEditCivilTeam}
                    name="ho_date_ce"
                    value={projectPayload.ho_date_ce}
                    onChange={handleChangeField}
                  />
                </Form.Group>
                <Form.Group as={Col} className="col-lg-6 col-md-12 mb-2">
                  <Form.Label
                    className={canEditCivilTeam ? "disabled-label" : ""}
                  >
                    Work module: Civil Team
                  </Form.Label>
                  <Form.Select
                    className="inputfield"
                    name="work_module_ct"
                    value={projectPayload.work_module_ct}
                    onChange={handleChangeField}
                    disabled={canEditCivilTeam}
                  >
                    <option hidden>Select work module</option>
                    {workModuleChoices.map((workModuleChoice) => {
                      return (
                        <option value={workModuleChoice["key"]}>
                          {workModuleChoice["display"]}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
              </Row>

              <Row>
                <Form.Group as={Col} className="col-lg-6 col-md-12 mb-2">
                  <Form.Label
                    className={canEditCivilTeam ? "disabled-label" : ""}
                  >
                    Execution Centre
                  </Form.Label>
                  <Form.Select
                    className="inputfield"
                    name="execution_centre"
                    value={projectPayload.execution_centre || ""}
                    onChange={handleChangeField}
                    disabled={canEditCivilTeam}
                  >
                    <option value="">Select execution centre</option>
                    {executionCentreChoices.map((choice) => {
                      return (
                        <option value={choice["key"]} key={choice["key"]}>
                          {choice["display"]}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
              </Row>

              <hr />
              <h6 className="mb-3 headingfive">Design Team</h6>

              <Row>
                  <Form.Group
                  controlId="formGridEmail"
                  className="col-md-12 col-lg-6 mb-2"
                >
                  <Form.Label className={canEditDesign ? "disabled-label" : ""}>
                    3D Closure Date
                  </Form.Label>
                  <Form.Control
                    type="date"
                    className="inputfield form-control date-control"
                    name="exp_3D_closure_date"
                    value={projectPayload.exp_3D_closure_date}
                    onChange={handleChangeField}
                    disabled={canEditDesign}
                  />
                </Form.Group>
                <Form.Group
                  controlId="formGridEmail"
                  className="col-md-12 col-lg-6 mb-2"
                >
                  <Form.Label className={canEditDesign ? "disabled-label" : ""}>
                    2D Closure Date
                  </Form.Label>
                  <Form.Control
                    type="date"
                    className="inputfield form-control date-control"
                    name="closure_date_2D"
                    value={projectPayload.closure_date_2D}
                    onChange={handleChangeField}
                    disabled={canEditDesign}
                  />
                </Form.Group>

              </Row>

              <Row>
                <Form.Group
                  controlId="formGridEmail"
                  className="col-md-12 col-lg-6 mb-2"
                >
                  <Form.Label className={canEditDesign ? "disabled-label" : ""}>
                    First 2D Release Date
                  </Form.Label>
                  <Form.Control
                    type="date"
                    className="inputfield form-control date-control"
                    name="first_2d_release_date"
                    value={projectPayload.first_2d_release_date || ""}
                    onChange={handleChangeField}
                    disabled={canEditDesign}
                  />
                </Form.Group>
              </Row>

              <hr />
              <h6 className="mb-3 headingfive">Sales Team (H/O Call)</h6>
              <Row>
                <Form.Group
                  className="col-md-12 col-lg-6 mb-2"
                  controlId="formGridEmail"
                >
                  <Form.Label
                    className={canEditSalesTeamHoCall ? "disabled-label" : ""}
                  >
                    Is Customer staying at site?
                  </Form.Label>
                  <Form.Control
                    type="text"
                    className="inputfield"
                    disabled={canEditSalesTeamHoCall}
                    value={projectPayload.material_selection_at_sales_ho}
                    onChange={handleChangeField}
                    name="material_selection_at_sales_ho"

                  />
                </Form.Group>

                <Form.Group
                  className="col-md-12 col-lg-6 mb-2"
                  controlId="formGridPassword"
                >
                  <Form.Label
                    className={canEditQuotationValue ? "disabled-label" : ""}
                  >
                    Net Quotation Amount
                  </Form.Label>
                  <Form.Control
                    type="number"
                    className="inputfield"
                    disabled={canEditQuotationValue}
                    value={projectPayload.quotation_value}
                    onChange={handleChangeField}
                    name="quotation_value"
                    min={QUOTATION_MIN}
                    step="1"
                    onKeyDown={(e) => {
                      const allowed = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"];
                      if (allowed.includes(e.key)) return;
                      if (!/^[0-9]$/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onWheel={(e) => e.target.blur()}
                  />
                  {projectPayload.quotation_value !== null && projectPayload.quotation_value !== "" && (
                    <Form.Text className="text-muted">
                      {parseInt(projectPayload.quotation_value, 10) > 0 && parseInt(projectPayload.quotation_value, 10) < QUOTATION_MIN ? (
                        <span style={{ color: "#dc3545" }}>Amount must be greater than 50,000</span>
                      ) : (
                        numberToIndianWords(projectPayload.quotation_value)
                      )}
                    </Form.Text>
                  )}
                </Form.Group>
              </Row>

              <Row>
                <Form.Group
                  className="col-md-12 col-lg-6 mb-2"
                  controlId="formGridDelayInsurance"
                >
                  <Form.Label
                    className={canEditDelayInsurance ? "disabled-label" : ""}
                  >
                    Delay Insurance
                  </Form.Label>
                  <Form.Select
                    className="inputfield"
                    disabled={canEditDelayInsurance}
                    value={projectPayload.delay_insurance === null || projectPayload.delay_insurance === undefined ? "" : (projectPayload.delay_insurance ? "yes" : "no")}
                    onChange={(e) => {
                      const val = e.target.value;
                      setProjectPayload({
                        ...projectPayload,
                        delay_insurance: val === "" ? null : (val === "yes"),
                      });
                    }}
                    name="delay_insurance"
                  >
                    <option value="">-- Select --</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </Form.Select>
                </Form.Group>
              </Row>

              <Row>
                <Form.Group
                  className="col-md-12 col-lg-6 mb-2"
                  controlId="formGridEmail"
                >
                  <Form.Label
                    className={canEditSalesTeamHoCall ? "disabled-label" : ""}
                  >
                    Materials Selection Closed on
                  </Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="ee"
                    className="inputfield form-control date-control"
                    disabled={canEditSalesTeamHoCall}
                    value={projectPayload.material_selection}
                    onChange={handleChangeField}
                    name="material_selection"

                  />
                </Form.Group>

                <Form.Group
                  className="col-md-12 col-lg-6 mb-2"
                  controlId="formGridPassword"
                >
                  <Form.Label
                    className={canEditHoDateSalesCe ? "disabled-label" : ""}
                  >
                   Handover planned by Sales
                  </Form.Label>
                  <Form.Control
                    type="date"
                    className="inputfield form-control date-control"
                    disabled={canEditHoDateSalesCe}
                    value={projectPayload.ho_date_sales_ce}
                    onChange={handleChangeField}
                    name="ho_date_sales_ce"

                  />
                </Form.Group>
              </Row>
              <Row>
                <Form.Group
                  className="col-md-12 col-lg-6 mb-2"
                  controlId="formGridEmail"
                >
                  <Form.Label
                    className={canEditSalesTeamHoCall ? "disabled-label" : ""}
                  >
                    Net Amount Received on
                  </Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="ee"
                    className="inputfield form-control date-control"
                    disabled={canEditSalesTeamHoCall}
                    value={projectPayload.received_on}
                    onChange={handleChangeField}
                    name="received_on"

                  />
                </Form.Group>

                <Form.Group
                  className="col-md-12 col-lg-6 mb-2"
                  controlId="formGridPassword"
                >
                  <Form.Label
                    className={canEditSalesTeamHoCall ? "disabled-label" : ""}
                  >
                    Net Amount Received
                  </Form.Label>
                  <Form.Control
                    type="number"
                    className="inputfield form-control"
                    disabled={canEditSalesTeamHoCall}
                    value={projectPayload.received_amount}
                    onChange={handleChangeField}
                    name="received_amount"

                  />
                </Form.Group>
              </Row>

              <hr />

              <h6 className="mb-3 headingfive">Accounts Team</h6>
              <Row>
                <Form.Group
                  className="col-md-12 col-lg-6 mb-2"
                  controlId="formGridEmail"
                >
                  <Form.Label
                    className={canEditAccounts ? "disabled-label" : ""}
                  >
                    Amount pending from customer (if any)
                  </Form.Label>
                  <Form.Control
                    name="final_amount_pending"
                    type="text"
                    className="inputfield"
                    value={projectPayload.final_amount_pending}
                    onChange={handleChangeField}
                    disabled={canEditAccounts}
                  />
                </Form.Group>

                <Form.Group
                  className="col-md-12 col-lg-6 mb-2"
                  controlId="formGridPassword"
                >
                  <Form.Label
                    className={canEditAccounts ? "disabled-label" : ""}
                  >
                    Final Amount Collected
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="final_amount_collected"
                    className="inputfield"
                    value={projectPayload.final_amount_collected}
                    onChange={(event) => {
                      const regex = /^[0-9\b]*(?![eE])$/;
                      if (regex.test(event.target.value)) {
                        handleChangeField(event);
                      }
                    }}
                    disabled={canEditAccounts}
                  />
                </Form.Group>
              </Row>

              <hr />
              {isEditing !== null && (
                <div className="d-flex justify-content-start align-items-start gap-2 mt-4">
                  <input
                    type="submit"
                    value="Submit"
                    className="signup_button"
                  />
                  <Outlinebutton
                    name="Cancel"
                    onClick={(event) => {
                      navigate("/salesprojects");
                    }}
                  />
                </div>
              )}
            </Form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Salesaddprojects;
